import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { ProfileAction, AIAction } from "../../store/actions";

import VisionAILayout from "./layout";
import WithMessages from "./withmessages";
import WithoutMessages from "./withoutmessages";

const VisionAI = () => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const profileData = useSelector((state) => state.profile?.user);
  const {
    aiSessions,
    aiDocs,
    isDocsLoading,
    isAddLoading,
    isMessagesLoading,
    isSessionsLoading,
  } = useSelector((state) => state.ai);

  const [activeSession, setActiveSession] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (auth?.user?.user?.id) {
      dispatch(ProfileAction.getUserProfile());
    }
  }, [auth]);

  useEffect(() => {
    if (profileData) {
      dispatch(AIAction.getAISessions());
      dispatch(AIAction.getAIDocs());
    }
  }, [profileData]);

  useEffect(() => {
    if (!activeSession) {
      setMessages([]);
    } else {
      const payload = { sessionId: activeSession };
      dispatch(
        AIAction.getAIMessages(payload, (res) => {
          if (res.status === 200) {
            setMessages(res.data);
          }
        })
      );
    }
  }, [activeSession]);

  const handleSendMessage = (prompt) => {
    const text = (prompt ?? message)?.trim();
    if (!text) return;

    const userMsg = {
      id: `local-${Date.now()}`,
      createdAt: new Date().toISOString(),
      role: "user",
      content: text,
    };

    setMessages((prev) => [...prev, userMsg]);
    setMessage("");

    const payload = {
      message: text,
      sessionId: activeSession ?? null,
    };

    setTimeout(() => {
      dispatch(
        AIAction.addAIMessage(payload, (res) => {
          const newSessionId = res?.data?.sessionId ?? activeSession;
          const serverMsg = res?.data;
          if (newSessionId && newSessionId !== activeSession) {
            setActiveSession(newSessionId);
            dispatch(AIAction.getAISessions());
          }
          setMessages((prev) => [...prev, serverMsg]);
        })
      );
    }, 500);
  };

  return (
    <VisionAILayout
      chat={aiSessions}
      setActiveSession={setActiveSession}
      activeSession={activeSession}
      profileData={profileData}
      sessionLoading={isSessionsLoading}
      aiDocs={aiDocs}
      isDocsLoading={isDocsLoading}
    >
      {activeSession ? (
        <WithMessages
          messages={messages}
          handleSendMessage={handleSendMessage}
          setMessage={setMessage}
          message={message}
          loading={isMessagesLoading}
          isAddLoading={isAddLoading}
          profileData={profileData}
        />
      ) : (
        <WithoutMessages
          handleSendMessage={handleSendMessage}
          profileData={profileData}
          setMessage={setMessage}
          message={message}
          isAddLoading={isAddLoading}
        />
      )}
    </VisionAILayout>
  );
};

export default VisionAI;
